import { render, staticRenderFns } from "./ResistPledgeDialog.vue?vue&type=template&id=008c907c&scoped=true&"
import script from "./ResistPledgeDialog.vue?vue&type=script&lang=js&"
export * from "./ResistPledgeDialog.vue?vue&type=script&lang=js&"
import style0 from "./ResistPledgeDialog.vue?vue&type=style&index=0&id=008c907c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008c907c",
  null
  
)

export default component.exports